












































































































































import Vue from 'vue';
import {
  ActionType,
  Url
} from '@/constants';
import { signOut } from '@/core';
import { isMobile } from '@/util';
import { mapGetters } from 'vuex';
export default Vue.extend({
  name: 'Header',
  components: {
    ImpersonationHeader: () => import('./components/ImpersonationHeader.vue')
  },
  data () {
    return {
      webDropdownOptions: {
        location: false,
        accounts: false
      },
      mobileDropdownOptions: {
        hamburgerMenu: false,
        accounts: true
      },
      baseUrl: Url.baseLocationUrl,
      showSearch: false,
      routeTo: '',
      showMessage: process.env.VUE_APP_SHOW_MESSAGE,
      showAppointment: process.env.VUE_APP_SHOW_APPOINTMENT
    };
  },
  props: {
    locations: {
      type: Object,
      required: true
    }
  },
  watch: {
    $route () {
      this.mobileDropdownOptions.hamburgerMenu = false;
      this.mobileDropdownOptions.accounts = true;
    }
  },
  created () {
    window.addEventListener('click', (e) => {
      const dropdown = document.querySelector('.dropdown-show');
      if (dropdown || this.mobileDropdownOptions.hamburgerMenu) {
        this.showSearch = false;
      }
      if (dropdown && !dropdown.contains(e.target as Node)) {
        this.toggleWebDropdowns('');
      }
    });
  },
  updated () {
    if (isMobile()) {
      this.repositionFeedbackButton();
    }
  },
  computed: {
    ...mapGetters(['user', 'haveMultipleJobs', 'isLoggedInAsAdmin', 'selectedJob', 'badges', 'signedIn', 'hasUserData']),
    isSignedIn (): boolean {
      return this.signedIn && this.hasUserData;
    }
  },
  methods: {
    async logout () {
      document.cookie = 'userCred =; expires=Thu, 01-Jan-1970 00:00:01 GMT';
      await signOut();
      window.location.href = Url.signoutHomePage;
    },
    toggleWebDropdowns (dropdown: string) {
      type webDropdown = 'location' | 'accounts';
      for (const [key, value] of Object.entries(this.webDropdownOptions)) {
        if (key === dropdown) {
          this.webDropdownOptions[key as webDropdown] = !this.webDropdownOptions[key as webDropdown];
        } else {
          this.webDropdownOptions[key as webDropdown] = false;
        }
      }
    },
    toggleMobileDropdowns (dropdown: string) {
      if (dropdown === 'hamburgerMenu') {
        this.mobileDropdownOptions.hamburgerMenu = !this.mobileDropdownOptions.hamburgerMenu;
        this.mobileDropdownOptions.accounts = this.mobileDropdownOptions.hamburgerMenu ? this.mobileDropdownOptions.accounts : true;
      } else {
        this.mobileDropdownOptions.accounts = !this.mobileDropdownOptions.accounts;
      }
    },
    toggleSearchBar () {
      this.showSearch = !this.showSearch;
      this.toggleWebDropdowns('');
      this.toggleMobileDropdowns('');
    },
    changeRoute () {
      window.location.href = this.baseUrl + this.routeTo;
    },
    repositionFeedbackButton () {
      const el = document.getElementById('atlwdg-trigger');
      el && el.classList.add('hidden');
    },
    async provideFeedback () {
      const el = document.getElementById('atlwdg-trigger');
      if (el) {
        await el.click();
      }
    },
    async endImpersonationSession () {
      this.$store.dispatch(ActionType.SET_LOGGED_IN_AS_ADMIN, false);
      this.$store.dispatch(ActionType.SET_IMPERSONATED_BUYER, '');
      await this.logout();
      window.close();
    }
  }
})
